import styled from "@emotion/styled"

export const MarginFix = styled.span({ display: "none" })
